import { registerAction } from '../../Action'

const CLEAR_DROP_DATA = 'CLEAR_DROP_DATA'

const reducer = (state = {}) => ({
  ...state,
  dropData: null,
})

const clearDropData = registerAction(CLEAR_DROP_DATA, { reducer })

export default clearDropData
